module.exports = __webpack_public_path__ + "img/transaksi-dijamin-aman.a151eaee.svg";